import { invisiblyApi } from 'src/redux/api/invisibly-api';
import { InvisiblyApiResponse } from 'src/services/api/api-response.types';
import { APITagType } from 'src/redux/api/invisibly-api.types';

export type ClientExclusionType = 'domain' | 'app';

export interface ClientExclusion {
  id: number;
  type: ClientExclusionType;
  value: string;
  created_at: string;
  created_by: number | null;
}

const clientExclusionsEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientExclusions: builder.query<ClientExclusion[], ClientExclusionType | void>({
      query: (type) => ({
        method: 'get',
        url: 'admin/exclusions',
        ...(type ? { params: { type } } : {}),
      }),
      transformResponse(response: InvisiblyApiResponse<ClientExclusion[]>) {
        return response.item ?? [];
      },
      providesTags: [{ id: 'LIST', type: APITagType.ClientExclusions }],
    }),
    createClientExclusion: builder.mutation<ClientExclusion, { type: ClientExclusionType; value: string }>({
      query: (data) => ({
        method: 'post',
        url: 'admin/exclusions',
        data,
      }),
      transformResponse(response: InvisiblyApiResponse<ClientExclusion>) {
        return response.item;
      },
      invalidatesTags: [{ id: 'LIST', type: APITagType.ClientExclusions }],
    }),
    deleteClientExclusion: builder.mutation<{ id: number }, number>({
      query: (id) => ({
        method: 'delete',
        url: `admin/exclusions/${id}`,
      }),
      transformResponse(response: InvisiblyApiResponse<{ id: number }>) {
        return response.item;
      },
      invalidatesTags: [{ id: 'LIST', type: APITagType.ClientExclusions }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetClientExclusionsQuery,
  useCreateClientExclusionMutation,
  useDeleteClientExclusionMutation,
} = clientExclusionsEndpoints;
